import React from 'react';
import { Table } from '../../components/Table';
import { useTheme } from '../../contexts/ThemeContext';

export const CashBalancePage: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>Остатки денежных средств</h2>
      <Table
        title="Остатки по кассам и счетам"
        columns={[
          { key: 'account_type', title: 'Тип счета', width: '20%' },
          { key: 'account_name', title: 'Название', width: '30%' },
          { key: 'currency', title: 'Валюта', width: '15%' },
          { key: 'balance', title: 'Остаток', width: '25%' },
          { key: 'last_update', title: 'Посл. обновление', width: '10%' }
        ]}
        data={[
          { id: '1', account_type: 'Касса', account_name: 'Касса №1', currency: 'KGS', balance: '45,230.50', last_update: '10:30', is_deleted: false },
          { id: '2', account_type: 'Касса', account_name: 'Касса №2', currency: 'USD', balance: '1,234.75', last_update: '09:45', is_deleted: false },
          { id: '3', account_type: 'Банк', account_name: 'Бакай Банк - Основной', currency: 'KGS', balance: '2,456,789.20', last_update: '08:00', is_deleted: false },
          { id: '4', account_type: 'Банк', account_name: 'Айыл Банк - Валютный', currency: 'USD', balance: '15,678.90', last_update: '08:00', is_deleted: false }
        ]}
        theme={theme}
        readOnly={true}
      />
    </div>
  );
};
